import { useQuery } from '@tanstack/react-query'

import { cubeApi } from '@/lib/cube'
import { parseReportErrors, parseReports } from '@/lib/cube-report'

/**
 * Kullanıcının görebildiği raporlar — route'lar, menü ve rapor sayfaları buradan
 * beslenir. Cube meta'sı token'daki izinlere göre süzülmüş gelir (izinsiz view hiç
 * yoktur) ve oturum içinde değişmez (deploy'a bağlı): bir kez çekilir.
 */
const metaQuery = { queryKey: ['cube', 'meta'], queryFn: () => cubeApi.meta(), staleTime: Infinity }

export function useReports() {
  return useQuery({ ...metaQuery, select: parseReports })
}

/** Meta'sı geçersiz olduğu için menüden düşen view'lar (aynı önbellek girdisi). */
export function useReportErrors(enabled: boolean) {
  return useQuery({ ...metaQuery, select: parseReportErrors, enabled })
}

/** Ham Cube meta (view/üye seçiciler için); `useReports` ile aynı önbellek girdisi. */
export function useCubeMeta() {
  return useQuery(metaQuery)
}
